import React, {useCallback, useMemo} from "react";
import {timingModeKeys} from "../../../z50-domaincomp/constants/timing-mode-keys";
import {Button} from "../../ui/button";
import {viewStates} from "./view-states";
import {useFormatTimerString} from "../../../hooks/useFormatTimerString";
import {useLazyCommand} from "@soap/modules";
import {useParams} from "react-router";

export function Welcome({e170, setViewState, hasInstructions}) {
    const {sharedAssessmentLinkId} = useParams();
    const [sendStartAssessmentCommand] = useLazyCommand("C276v1_StartAssessment");
    
    const timingPhrase = useMemo(() => {
        if (e170) {
            const key = e170.e170_TimingModeKey;
            const phrases = {
                [timingModeKeys.PerSection]: "Each section is timed individually.",
                [timingModeKeys.PerQuestion]: "Each question is timed individually."
            };
            return phrases[key] || "";
        }
    }, [e170]);
    
    const {fromSeconds} = useFormatTimerString();
    const sectionCount = e170.e170_NumberOfSections;
    const questionCount = e170?.e170_NumberOfQuestions;
    
    // Check if StudentId is available from SharedAssessment (no need to collect details)
    const hasStudentId = e170?.e170_Student?.e170_StudentId != null;

    const handleStartAssessment = async () => {
        if (hasStudentId) {
            // Start directly when StudentId is available
            await sendStartAssessmentCommand({
                C276_SharedAssessmentId: sharedAssessmentLinkId
            });
        } else {
            // For anonymous shares, still need to collect email (fallback to old flow for now)
            // TODO: Implement simplified email collection for anonymous shares
            setViewState(hasInstructions ? viewStates.showInstructions : viewStates.showQuestion);
        }
    };

    return (
        <div className="space-y-6">
            <div className="text-center">
                <h2 className="text-2xl font-semibold text-gray-900 mb-6">{e170.e170_AssessmentTitle}</h2>
            </div>
            
            <div className="space-y-4 text-gray-700">
                <p>You are about to take an assessment.</p>

                <p>The assessment is made up of {sectionCount} section{sectionCount === 1 ? "" : "s"} with a total of {questionCount} question{questionCount === 1 ? "" : "s"}.</p>
                
                <p>This assessment is {timingModeKeys.NotTimed === e170.e170_TimingModeKey ? "not" : ""} timed. {e170.e170_TimingModeKey !== timingModeKeys.NotTimed ?
                        `You will have a maximum of ${fromSeconds(e170.e170_TimeLimit)} to complete the assessment.` : null} {timingPhrase}</p>
                
                {hasInstructions &&
                    <p>Further instructions have been provided by the assessment author on the following page.</p>
                }
                <p>
                    You will not be able to restart the assessment once started.<br/>
                    Please ensure you have a stable internet connection.</p>
                <p>
                    If using a touchscreen device, answering essay questions without a keyboard may add time.
                </p>
            </div>
            
            <div className="flex justify-end pt-4">
                <Button 
                    onClick={() => {
                        if (hasInstructions) {
                            setViewState(viewStates.showInstructions);
                        } else {
                            handleStartAssessment();
                        }
                    }}
                    className="px-6 py-2"
                >
                    Continue
                </Button>
            </div>
        </div>
    );
}




